import {Injectable} from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {environment} from "../../../environments/environment";
import {AuthenticationService} from "../../services/authentication.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.apiUrl)) {
      const authState = this.authService.getAuthStateSnapshot();

      if (!authState.isLoggedIn) { // TODO does not work as intended
        this.authService.refreshUserState().then(
          () => {
            const refreshedAuthState = this.authService.getAuthStateSnapshot();
            if (!refreshedAuthState.isLoggedIn) {
              return next.handle(req);
              //TODO sorry, cannot help you, go away
            } else {
              req = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${refreshedAuthState.authToken}`
                }
              });

              return next.handle(req);
            }
          }
        )
      } else {
        req = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authState.authToken}`
          }
        });

        return next.handle(req);
      }
    }

    return next.handle(req);
  }
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            this.authService.signOut();
          }
          // else if (error.status === 0) {
          //   this.authService.signOut();
          // }

          // Propagate any other errors
          return throwError(() => error);
        })
      );
  }
}

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
];
